import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.scss']
})
export class MapaComponent implements OnInit {

  inmuebles: any[] = [];

  results = 50;
  tipo = 'APARCAMIENTOS';
  ciudad = 'ELCHE';
  zona = 'CENTRO';
  alquilado = '';
  label = 'disponibilidad';

  error_level = 0;

  lat = 38.2679238;
  lng = -0.7043759000000591;

  constructor(private rest: RestService) {
    this.getLocation(15);
  }

  ngOnInit() {
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`);
  }

  getLocation(results) {
    this.rest.getGeolocation(results, this.tipo, this.ciudad, this.alquilado, this.label, this.zona)
      .subscribe((data) => {
        this.inmuebles = data['data'];
      });
  }

  parseInt(value) {
    let number: number;
    number = value.parseInt;

    return number;
  }

  viewResults() {
    this.getLocation(this.results);
  }

}
